<template>
  <div id="preview" class="professional-approval-modal">
    <overlay-loading-progress :LoadingFlag="OverlayLoadingFlag" />
    
    <v-card class="approval-modal-card" elevation="12">
      <!-- Professional Header -->
      <div class="professional-header">
        <div class="header-content">
          <div class="header-left">
            <div class="icon-section">
              <v-icon size="32" color="white">mdi-account-check</v-icon>
            </div>
            <div class="title-section">
              <h2 class="modal-title">{{ pageDescription }}</h2>
              <p class="modal-subtitle">Review and approve nomination application</p>
            </div>
          </div>
          <div class="header-actions">
            <v-btn
              icon
              large
              color="white"
              class="close-btn"
              @click="closePrompt"
            >
              <v-icon size="24">mdi-close</v-icon>
            </v-btn>
          </div>
        </div>
      </div>

      <!-- Professional Content Area -->
      <v-card-text class="professional-content pa-0">
        <div class="content-container">
          <!-- Previous Approval Description Section -->
          <div class="approval-history-section" v-if="recordData.ConfirmationDescriptionHistory != ''">
            <div class="section-header">
              <v-icon color="#2ecc71" class="mr-3">mdi-history</v-icon>
              <span class="section-title">Previous Approval History</span>
            </div>
            <div class="history-content">
              <div class="history-wrapper" v-html="recordData.ConfirmationDescriptionHistory"></div>
            </div>
          </div>

          <!-- Approval Form Section -->
          <div class="approval-form-section">
            <div class="section-header">
              <v-icon color="#1976d2" class="mr-3">mdi-clipboard-text</v-icon>
              <span class="section-title">Approval Decision</span>
            </div>

            <div class="form-container">
              <v-form
                ref="form2"
                v-model="valid1"
                lazy-validation
                v-on:submit.prevent="submitForm"
                class="approval-form"
              >
                <!-- Description Field -->
                <div class="form-group">
                  <label class="field-label">
                    <v-icon color="#1976d2" class="mr-2">mdi-text</v-icon>
                    <span>Approval Description</span>
                    <span class="required-indicator">*</span>
                  </label>
                  <p class="field-description">
                    Please provide detailed comments regarding your approval decision
                  </p>
                  <v-textarea
                    v-model="Description"
                    :rules="DescriptionRules"
                    outlined
                    rows="4"
                    placeholder="Enter your approval comments here..."
                    class="description-field"
                    hide-details="auto"
                  ></v-textarea>
                </div>

                <!-- Action Buttons Section -->
                <div class="action-section">
                  <div class="action-wrapper">
                    <div class="primary-actions">
                      <v-btn
                        :disabled="!valid1"
                        @click.prevent="submitForm(1)"
                        color="#2ecc71"
                        elevation="4"
                        rounded
                        large
                        class="action-btn approve-btn"
                      >
                        <v-icon left size="20">mdi-check-circle</v-icon>
                        Approve Application
                      </v-btn>
                      <v-btn
                        :disabled="!valid1"
                        @click.prevent="submitForm(3)"
                        color="#e74c3c"
                        elevation="4"
                        rounded
                        large
                        class="action-btn reject-btn ml-3"
                      >
                        <v-icon left size="20">mdi-close-circle</v-icon>
                        Reject Application
                      </v-btn>
                    </div>
                    <div class="secondary-actions mt-3">
                      <v-btn
                        @click="closePrompt"
                        outlined
                        color="#666"
                        elevation="0"
                        rounded
                        large
                        class="action-btn cancel-btn"
                      >
                        <v-icon left size="20">mdi-arrow-left</v-icon>
                        Cancel & Go Back
                      </v-btn>
                    </div>
                  </div>
                </div>
              </v-form>
            </div>
          </div>
        </div>
      </v-card-text>
    </v-card>
  </div>
</template>


<script>
import common from "@/view/Common.vue";
import companyConfig from "@/company_config.json";

export default {
  mixins: [common],
  components: {},
  props: {
    row: {
      required: true,
    },
    pageDescription: {
      type: String,
    },
  },
  data() {
    return {
      recordData: [],
      TrainingDocuments: [],
      ResultFlag: false,

      OverlayLoadingFlag: false,
      ReportType: "",
      valid1: true,
      Description: "",
      DescriptionRules: [(v) => !!v || "Description is required"],
    };
  },
  computed: {},
  watch: {
    dialog(val) {
      val || this.close();
    },
    dialogDelete(val) {
      val || this.closeDelete();
    },
    recordData: function () {
      console.log("watch recordData");
      this.OverlayLoadingFlag = false;
      var tr = this.recordData;
      console.log({ tr });
      var n1 = Object.keys(tr).length;
      console.log({ n1 });
      this.TrainingDocuments = n1 > 0 ? tr.TrainingDocuments : [];
    },
  },
  created() {
    // this.initialize()
  },
  methods: {
    closePrompt() {
      console.log("closePrompt called");
      this.$emit("hideDialog", this.ResultFlag);
    },
    validate() {
      console.log("validate is called");
      var result = this.$refs.form.validate();
      console.log("result=" + result);
      if (result) {
        this.addRecordDetails();
      } else {
        console.log("some errors occured");
      }
    },
    refreshPageData() {
      console.log("refreshPageData called");
      this.getRecordDetails();
    },
    getRecordDetails() {
      console.log("getRecordDetails called");
      this.OverlayLoadingFlag = true;
      this.TrainingDocuments = [];
      var tr = this.row;
      console.log({ tr });
      var id = tr.NominationId;
      var list_url = "api/nomination/show";
      var where = {
        Nomination: id,
      };
      console.log("list_url=" + list_url + ", where=" + JSON.stringify(where));
      this.getTableData("recordData", list_url, where);
    },
    submitForm(Status) {
      console.log("submitForm is called");

      console.log({ Status });

      var message = "";

      var validate1 = this.$refs.form2.validate();
      console.log({ validate1 });

      var tr = this.row;
      console.log({ tr });

      var id = tr.NominationId;
      console.log(id);

      // var validate1 = false;

      if (validate1 && Status > 0 && id > 0) {
        this.OverlayLoadingFlag = true;
        this.ResultFlag = false;

        var server_url = companyConfig.apiURL;
        var token = this.$session.get("token");
        token = token == (null || undefined) ? 0 : token;
        var add_url = server_url + "api/nomination/president-approval-update";
        var upload = {
          UserInterface: Status,
          Nomination: id,
          Description: this.Description,
          Lom: tr.LomId,
        };
        console.log("upload=" + JSON.stringify(upload));
        console.log(
          "server_url=" +
            server_url +
            ", token=" +
            token +
            ", add_url=" +
            add_url
        );

        const thisIns = this;
        var output = "";
        var flag = 0;

        this.$http({
          url: add_url,
          method: "POST",
          data: upload,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
          onUploadProgress: function (progressEvent) {
            this.uploadPercentage = parseInt(
              Math.round((progressEvent.loaded / progressEvent.total) * 100)
            );
          }.bind(this),
        })
          .then(function (response) {
            console.log("response=" + JSON.stringify(response));
            thisIns.OverlayLoadingFlag = false;

            output = response.data.output;
            flag = response.data.flag;
            console.log("output=" + output + ", flag=" + flag);

            if (flag == 1) {
              thisIns.ResultFlag = true;
              thisIns.sweetAlert("success", output, true);
              thisIns.closePrompt();
            } else {
              thisIns.sweetAlert("error", output, false);
            }
          })
          .catch(function (error) {
            console.log("error=" + error);
            thisIns.OverlayLoadingFlag = false;
          });
      } else {
        if (!validate1) {
          message = "Kindly fill the required fields. ";
        }
        if (Status == null || Status == "") {
          message = "Status is invalid. ";
        }
        this.sweetAlert("error", message, false);
      }
    },
  },
  beforeMount() {
    this.refreshPageData();
  },
};
</script>

<style lang="scss" scoped>
.professional-approval-modal {
  .approval-modal-card {
    border-radius: 16px !important;
    overflow: hidden;
    max-width: 900px;
    width: 100%;
    margin: auto;
    background: #ffffff;
    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.15) !important;

    // Professional Header Styles - Matching VotingDescription
    .professional-header {
      background: linear-gradient(135deg, #1976d2 0%, #1565c0 100%);
      color: white;
      position: relative;
      overflow: hidden;

      &::before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='0.05'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E") repeat;
        opacity: 0.1;
      }

      .header-content {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 2rem;
        position: relative;
        z-index: 1;

        .header-left {
          display: flex;
          align-items: center;
          flex: 1;

          .icon-section {
            background: rgba(255, 255, 255, 0.2);
            border-radius: 50%;
            width: 56px;
            height: 56px;
            display: flex;
            align-items: center;
            justify-content: center;
            margin-right: 1.5rem;
            backdrop-filter: blur(10px);
            border: 2px solid rgba(255, 255, 255, 0.3);
          }

          .title-section {
            .modal-title {
              font-size: 1.75rem;
              font-weight: 700;
              margin: 0 0 0.25rem 0;
              color: white;
              font-family: 'Roboto', sans-serif;
              line-height: 1.2;
              text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
            }

            .modal-subtitle {
              font-size: 1rem;
              color: rgba(255, 255, 255, 0.9);
              margin: 0;
              font-weight: 400;
              opacity: 0.95;
            }
          }
        }

        .header-actions {
          .close-btn {
            background: rgba(255, 255, 255, 0.2) !important;
            backdrop-filter: blur(10px);
            border: 2px solid rgba(255, 255, 255, 0.3);
            transition: all 0.3s ease;

            &:hover {
              background: rgba(255, 255, 255, 0.3) !important;
              transform: rotate(90deg);
            }
          }
        }
      }
    }

    // Professional Content Styles - Matching VotingDescription
    .professional-content {
      .content-container {
        padding: 0;

        // Approval History Section
        .approval-history-section {
          padding: 2rem;
          border-bottom: 1px solid #f0f2f5;

          .section-header {
            display: flex;
            align-items: center;
            margin-bottom: 1.5rem;
            padding-bottom: 1rem;
            border-bottom: 2px solid #f8f9fa;

            .section-title {
              font-size: 1.25rem;
              font-weight: 600;
              color: #2c3e50;
              font-family: 'Roboto', sans-serif;
            }
          }

          .history-content {
            .history-wrapper {
              background: #f8fafc;
              border: 1px solid #e2e8f0;
              border-radius: 12px;
              padding: 2rem;
              line-height: 1.8;
              font-size: 1rem;
              color: #374151;
              position: relative;
              box-shadow: 0 2px 4px rgba(0, 0, 0, 0.02);

              &::before {
                content: '';
                position: absolute;
                top: 0;
                left: 0;
                width: 4px;
                height: 100%;
                background: linear-gradient(to bottom, #2ecc71, #27ae60);
                border-radius: 2px 0 0 2px;
              }

              // Enhanced typography for history content
              ::v-deep {
                h1, h2, h3, h4, h5, h6 {
                  color: #2c3e50 !important;
                  font-weight: 600 !important;
                  margin: 1.5rem 0 1rem 0 !important;
                  font-family: 'Roboto', sans-serif !important;
                  line-height: 1.4 !important;
                }

                h1 { font-size: 1.75rem !important; }
                h2 { font-size: 1.5rem !important; }
                h3 { font-size: 1.3rem !important; }
                h4 { font-size: 1.2rem !important; }
                h5 { font-size: 1.1rem !important; }
                h6 { font-size: 1rem !important; }

                p {
                  margin: 1rem 0 !important;
                  line-height: 1.8 !important;
                  color: #374151 !important;
                  font-size: 1rem !important;
                }

                ul, ol {
                  margin: 1rem 0 1rem 1.5rem !important;
                  
                  li {
                    margin: 0.5rem 0 !important;
                    line-height: 1.6 !important;
                    color: #374151 !important;
                  }
                }

                strong, b {
                  color: #2ecc71 !important;
                  font-weight: 600 !important;
                }

                em, i {
                  color: #666 !important;
                  font-style: italic !important;
                }
              }
            }
          }
        }

        // Approval Form Section
        .approval-form-section {
          padding: 2rem;
          border-bottom: 1px solid #f0f2f5;

          .section-header {
            display: flex;
            align-items: center;
            margin-bottom: 1.5rem;
            padding-bottom: 1rem;
            border-bottom: 2px solid #f8f9fa;

            .section-title {
              font-size: 1.25rem;
              font-weight: 600;
              color: #2c3e50;
              font-family: 'Roboto', sans-serif;
            }
          }

          .form-container {
            .approval-form {
              .form-group {
                margin-bottom: 2rem;

                .field-label {
                  display: flex;
                  align-items: center;
                  font-size: 1.1rem;
                  font-weight: 600;
                  color: #2c3e50;
                  margin-bottom: 0.5rem;
                  font-family: 'Roboto', sans-serif;

                  .required-indicator {
                    color: #e74c3c;
                    margin-left: 4px;
                    font-size: 1.2rem;
                  }
                }

                .field-description {
                  font-size: 0.9rem;
                  color: #666;
                  margin: 0.5rem 0 1rem 0;
                  line-height: 1.5;
                }

                .description-field {
                  ::v-deep {
                    .v-input__control {
                      .v-input__slot {
                        background: #f8fafc !important;
                        border: 1px solid #e2e8f0 !important;
                        border-radius: 12px !important;
                        transition: all 0.3s ease !important;
                        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.02) !important;

                        &:hover {
                          border-color: #cbd5e1 !important;
                          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05) !important;
                        }

                        .v-text-field__slot {
                          padding: 16px 20px !important;

                          textarea {
                            font-size: 1rem !important;
                            line-height: 1.7 !important;
                            color: #374151 !important;
                            font-family: 'Roboto', sans-serif !important;

                            &::placeholder {
                              color: #9ca3af !important;
                              font-style: italic;
                            }
                          }
                        }
                      }

                      &.v-input--is-focused {
                        .v-input__slot {
                          border-color: #1976d2 !important;
                          box-shadow: 0 0 0 3px rgba(25, 118, 210, 0.1) !important;
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }

        // Action Section - Matching VotingDescription style
        .action-section {
          padding: 2rem;
          background: linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%);
          border-top: 1px solid #e9ecef;

          .action-wrapper {
            display: flex;
            justify-content: center;
            align-items: center;
            flex-direction: column;
            gap: 1rem;

            .primary-actions {
              display: flex;
              gap: 1rem;
              margin-bottom: 0.5rem;
            }

            .secondary-actions {
              display: flex;
            }

            .action-btn {
              font-weight: 600 !important;
              text-transform: none !important;
              letter-spacing: 0.5px !important;
              padding: 0 32px !important;
              height: 48px !important;
              font-size: 1rem !important;
              border-radius: 24px !important;
              transition: all 0.3s ease !important;
              font-family: 'Roboto', sans-serif !important;

              &.approve-btn {
                background: linear-gradient(135deg, #2ecc71 0%, #27ae60 100%) !important;
                box-shadow: 0 4px 15px rgba(46, 204, 113, 0.3) !important;

                &:hover {
                  transform: translateY(-2px) !important;
                  box-shadow: 0 8px 25px rgba(46, 204, 113, 0.4) !important;
                }

                &:disabled {
                  background: #bdc3c7 !important;
                  box-shadow: none !important;
                  transform: none !important;
                }
              }

              &.reject-btn {
                background: linear-gradient(135deg, #e74c3c 0%, #c0392b 100%) !important;
                box-shadow: 0 4px 15px rgba(231, 76, 60, 0.3) !important;

                &:hover {
                  transform: translateY(-2px) !important;
                  box-shadow: 0 8px 25px rgba(231, 76, 60, 0.4) !important;
                }

                &:disabled {
                  background: #bdc3c7 !important;
                  box-shadow: none !important;
                  transform: none !important;
                }
              }

              &.cancel-btn {
                border: 2px solid #e2e8f0 !important;
                color: #64748b !important;

                &:hover {
                  border-color: #cbd5e1 !important;
                  background: #f8fafc !important;
                  transform: translateY(-1px) !important;
                }
              }
            }
          }
        }
      }
    }
  }
}

// Responsive Design - Matching VotingDescription
@media (max-width: 768px) {
  .professional-approval-modal {
    .approval-modal-card {
      margin: 1rem;
      max-width: calc(100vw - 2rem);

      .professional-header {
        .header-content {
          padding: 1.5rem;

          .header-left {
            .icon-section {
              width: 48px;
              height: 48px;
              margin-right: 1rem;
            }

            .title-section {
              .modal-title {
                font-size: 1.5rem;
              }

              .modal-subtitle {
                font-size: 0.9rem;
              }
            }
          }
        }
      }

      .professional-content {
        .content-container {
          .approval-history-section,
          .approval-form-section {
            padding: 1.5rem;
          }

          .action-section {
            padding: 1.5rem;

            .action-wrapper {
              .primary-actions {
                flex-direction: column;
                gap: 12px;
                width: 100%;

                .action-btn {
                  width: 100%;
                  max-width: 280px;
                }
              }

              .secondary-actions {
                width: 100%;

                .cancel-btn {
                  width: 100%;
                  max-width: 280px;
                }
              }
            }
          }
        }
      }
    }
  }
}

@media (max-width: 480px) {
  .professional-approval-modal {
    .approval-modal-card {
      margin: 0.5rem;

      .professional-header {
        .header-content {
          padding: 1rem;

          .header-left {
            .icon-section {
              width: 40px;
              height: 40px;
              margin-right: 0.75rem;
            }

            .title-section {
              .modal-title {
                font-size: 1.25rem;
              }

              .modal-subtitle {
                font-size: 0.85rem;
              }
            }
          }
        }
      }

      .professional-content {
        .content-container {
          .approval-history-section,
          .approval-form-section {
            padding: 1rem;
          }

          .approval-form-section {
            .form-container {
              .approval-form {
                .form-group {
                  .description-field {
                    ::v-deep {
                      .v-input__control {
                        .v-input__slot {
                          .v-text-field__slot {
                            padding: 12px 16px !important;

                            textarea {
                              font-size: 0.9rem !important;
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }

          .action-section {
            padding: 1rem;
          }
        }
      }
    }
  }
}
</style>